export const buildingInclude =
	'clients:withoutBanned(true),buildingProductStates.product';
